export const GENERAL_SETTINGS = {
    CONSENT_NOT_RESPONDED: "isConsentNotResponded",
}